module.exports = __webpack_public_path__ + "img/a3.1c9a9b42.png";